<template>
    <div class="purchase-online-card">
        <div class="purchase-online-card-title" v-if="displayTitle && eligibleForRenewal">Buy your policy online</div>
        <div class="purchase-online-card-title" v-if="displayTitle && !eligibleForRenewal">Your policy can not be purchased online</div>

        <div class="purchase-online-card-body"  v-if="eligibleForRenewal">
            <button class="purchase-online-card-button" :disabled="purchaseDisabled" @click="$router.push({path: '/purchase-policy/payment'});">Purchase Online</button><br/>
            
            <div class="purchase-online-card-total-amt-payable" v-if="paymentTerms === 'annual'">
                <img class="purchase-online-card-card-img" src="https://uploads.staging.oregon.platform-os.com/instances/1410/assets/images/visa-xs.png" />
                <img class="purchase-online-card-card-img" src="https://uploads.staging.oregon.platform-os.com/instances/1410/assets/images/master-card-xs.png" />
                <div>Total amount payable: ${{totalPayable}}</div>
            </div>
            
            <div class="purchase-online-card-total-amt-payable" v-if="paymentTerms === 'monthly' || paymentTerms === 'fortnightly'">
                <v-layout align-center justify-center row wrap>
                    <v-flex><!-- md1 offset-md2 -->
                         <img class="purchase-online-card-card-img" src="https://uploads.staging.oregon.platform-os.com/instances/1410/assets/images/elantis-xs.png" /> 
                    </v-flex>
                    <v-flex v-if="paymentTerms === 'monthly'"
                    style="text-align: left;"> <!-- md7 offset-md1 -->
                        Upfront 2 monthly payments of $97.50<br/>
                        Followed by 10 monthly payments of ${{ Number(this.totalPayable) > 0 ? ((Number(this.totalPayable) - 195) / 10).toFixed(2) : 0 }}<br/>
                        Total amount payable: ${{ totalPayable }}<br/>
                        Includes 10% interest
                    </v-flex>
                    <v-flex v-if="paymentTerms === 'fortnightly'"
                    style="text-align: left;"> <!-- md7 offset-md1 -->
                        Upfront 2 monthly payments of $97.50<br/>
                        Followed by 22 fortnightly payments of ${{ Number(this.totalPayable) > 0 ? ((Number(this.totalPayable) - 195) / 22).toFixed(2) : 0 }}<br/>
                        Total amount payable: ${{ totalPayable }}<br/>
                        Includes 10% interest
                    </v-flex>
                </v-layout>
            </div>

        </div>

        <div class="purchase-online-card-body not-eligible" v-if="!eligibleForRenewal">
            An FDCA Customer Service Representative will check you policy and process your policy over the phone.
        </div>

        <div class="purchase-online-card-footer"
        :class="{'ineligible': !eligibleForRenewal}">
            <div class="first-text-line" v-if="eligibleForRenewal">Need to add an additional cover or a dual educator?</div>
            <div class="second-text-line">
                <font-awesome-icon :icon="['fas', 'phone-alt']" />&nbsp;CALL US ON: 1800 658 699
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OnlineRenewalPurchaseRenewal",
    props: {
        displayTitle: Boolean,
        totalPayable: String,
        paymentTerms: String,
        monthlyPayment: Number,
        fortnightlyPayment: Number,
        eligibleForRenewal: Boolean,
        purchaseDisabled: Boolean,
    },
    data(){
        return {
            totalMonthly: 0,
            totalFortnightly: 0
        }
    }
}
</script>

<style>
.purchase-online-card {
    background: white;
    border: 1px solid #e4e6ed;
    border-radius: 10pt;
    box-shadow: 1px 1px 3px #e4e6ed;
    color: black;
    text-align: center;
}
.purchase-online-card .purchase-online-card-title {
    font-size: 24px;
    font-weight: bold;
    padding: 10px 20px;
}
.purchase-online-card-body {
    padding: 30px 15px;
}
.purchase-online-card-body.not-eligible {
    font-size: 14px;
    line-height: 20px;
}
.purchase-online-card-button {
    background-color: #1cb052 !important;
    border-radius: 20pt;
    color: white !important;
    margin-bottom: 20px;
    padding: 12px 60px;   
    text-transform: uppercase;
}
.purchase-online-card-total-amt-payable {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    font-size: 0.9rem;
    font-weight: lighter;
    justify-content: center;
    margin-bottom: 20px;
}
.purchase-online-card-card-img {
    margin-right: 5px;
}
.purchase-online-card-footer {
    background-color: #e6f1f9;
    border-bottom-left-radius: 10pt;
    border-bottom-right-radius: 10pt;
    padding: 20px 0;
}
.purchase-online-card-footer.ineligible {
    background-color: #fdf5f4;
    color: #D93B20;
}
.purchase-online-card-footer .first-text-line {
    font-size: 14px;
    margin-bottom: 10px;
}
.purchase-online-card-footer .second-text-line {
    font-weight: bolder;
}
</style>